// @ts-nocheck
import { infoProps } from "@store/Themes/common/props/info";
import { approverStyles, OrderDetailsApproverStyles } from "@store/Library/Widgets/OrderDetails/OrderDetailsApprover";

Object.assign<OrderDetailsApproverStyles>(approverStyles, {
    wrapper: {},
    titleText: infoProps.label,
    approver: infoProps.value,
});
